var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"inputRef",attrs:{"type":"text","disabled":_vm.disabledFlag},on:{"click":_vm.onClick,"blur":_vm.onBlur,"focus":_vm.onFocus}})
}
var staticRenderFns = []

export { render, staticRenderFns }